import { AppConstants } from "../../../../core/constants/constants";
import { Likes } from "../../domain/entities/userMatch";
import { LikesParams } from "../../domain/entities/getLikesParams";
import { MatchesSearch } from "../../domain/entities/userUnjabbed";
import { MatchSearchParams } from "../../domain/entities/getMatchSearchParams";
import { ReportSubject } from "../../domain/entities/getReportSubject";
import { MatchRepository } from "../../domain/repositories/MatchRepository";
import { MatchDataSource } from "../datasource/MatchDataSource";
import { UserInfoProfile } from "../../domain/entities/userInfoProfile";
import { DeleteBlockMatchParams } from "../../domain/entities/deleteBlockMatchParams";
import { LikesYouResponse } from "../../domain/entities/likesYou";

export class MatchRepositoryImpl implements MatchRepository {
	constructor(private dataSource: MatchDataSource) {}
	getMatchSearch(params: MatchSearchParams): Promise<MatchesSearch> {
		return AppConstants.getRightOrLeftSide<MatchesSearch>(
			this.dataSource.getMatchSearch(params)
		);
	}
	getLikes(params: LikesParams): Promise<LikesYouResponse> {
		return AppConstants.getRightOrLeftSide<LikesYouResponse>(
			this.dataSource.getLikes(params)
		);
	}
	getMyLikes(params: LikesParams): Promise<Likes[]> {
		return AppConstants.getRightOrLeftSide<Likes[]>(
			this.dataSource.getMyLikes(params)
		);
	}
	getMyMatches(params: LikesParams): Promise<Likes[]> {
		return AppConstants.getRightOrLeftSide<Likes[]>(
			this.dataSource.getMyMatches(params)
		);
	}
	getMyNewMatches(params: LikesParams): Promise<Likes[]> {
		return AppConstants.getRightOrLeftSide<Likes[]>(
			this.dataSource.getMyNewMatches(params)
		);
	}
	deleteLike(match_id: string): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.deleteLike(match_id)
		);
	}
	rejectMatch(match_id: string): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.rejectMatch(match_id)
		);
	}
	getReportSubject(): Promise<ReportSubject[]> {
		return AppConstants.getRightOrLeftSide<ReportSubject[]>(
			this.dataSource.getReportSubject()
		);
	}
	createOrderPaypal(product_id: string, quantity: number): Promise<string> {
		return AppConstants.getRightOrLeftSide<string>(
			this.dataSource.createOrderPaypal(product_id, quantity)
		);
	}
	sendPaidMessage(user_id: string, message: string): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.sendPaidMessage(user_id, message)
		);
	}
	getUserInfoById(params: { user_id: string, user_lat: string, user_lng: string }): Promise<UserInfoProfile> {
		return AppConstants.getRightOrLeftSide<UserInfoProfile>(
			this.dataSource.getUserInfoById(params)
		);
	}
	deleteTrashUser(user_id: string): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.deleteTrashUser(user_id)
		);
	}
	deleteBlockMatch(params: DeleteBlockMatchParams): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.deleteBlockMatch(params)
		);
	}
}
